import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => {
    if (process.env.NODE_ENV !== 'production') {
        if (props['aria-hidden'] !== 'true' && props['aria-label'] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" }) }));
};
export default SvgArrowLeft;
